import { Briefcase, Calendar, Cpu, Gauge, Globe, Layers, ShieldCheck } from "lucide-react";
import useCountUpOnView from "../components/useCountUpOnView";
import TechSectionHeader from "./TechSectionHeader";
import "./tech-philosophy.css";

export default function TechPhilosophy() {
  const years = useCountUpOnView(8);
  const projects = useCountUpOnView(100);
  const reliability = useCountUpOnView(99);

  return (
    <section className="oglitz-tech-philosophy">
      <div className="oglitz-tech-philosophy__bg" />

      <div className="oglitz-tech-philosophy__container">
        <TechSectionHeader
          eyebrow="OUR PHILOSOPHY"
          title="Our Technology"
          highlight="Philosophy"
          subtitle="We engineer systems with intention — focusing on long-term stability, performance, and business resilience."
        />

        {/* CARDS */}
        <div className="oglitz-tech-philosophy__grid">
          {[
            {
              icon: <Layers />,
              title: "Future-Ready Architecture",
              text: "Modular systems designed to evolve with business growth.",
            },
            {
              icon: <ShieldCheck />,
              title: "Security-First Engineering",
              text: "Security embedded across architecture and workflows.",
            },
            {
              icon: <Gauge />,
              title: "Performance at Scale",
              text: "Optimized for speed, reliability, and consistency.",
            },
            {
              icon: <Cpu />,
              title: "Maintainable by Design",
              text: "Clean architecture and maintainable codebases.",
            },
          ].map((item, i) => (
            <div key={i} className="oglitz-tech-philosophy__card">
              <span className="oglitz-tech-philosophy__line" />
              <div className="oglitz-tech-philosophy__icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        {/* METRICS */}
        <div className="oglitz-tech-philosophy__metrics">
          <div className="oglitz-metric">
            <span className="oglitz-metric__icon">
              <Calendar size={20} />
            </span>
            <strong>8+</strong>
            <p>Years Experience</p>
          </div>

          <div className="oglitz-metric">
            <span className="oglitz-metric__icon">
              <Briefcase size={20} />
            </span>
            <strong>100+</strong>
            <p>Projects Delivered</p>
          </div>

          <div className="oglitz-metric">
            <span className="oglitz-metric__icon">
              <ShieldCheck size={20} />
            </span>
            <strong>99.9%</strong>
            <p>System Reliability</p>
          </div>

          <div className="oglitz-metric">
            <span className="oglitz-metric__icon">
              <Globe size={20} />
            </span>
            <strong>Global</strong>
            <p>Client Reach</p>
          </div>
        </div>
      </div>
    </section>
  );
}
